import { useQuery } from "@tanstack/react-query";
import axios from "axios";
import { API_BASE_URL } from "@config/config";

const fetchSubscriberGroup = async (groupCode) => {
    const res = await axios.get(`${API_BASE_URL}/subscriber-group/${groupCode}`);
    return res.data.data;
};

export const useSubscriberGroup = (groupCode) => {
    const { data, isLoading } = useQuery({
        queryKey: ["subscriberGroup", groupCode],
        queryFn: () => fetchSubscriberGroup(groupCode),
        enabled: !!groupCode,
        staleTime: Infinity,
    });

    return {
        subscriberGroup: data ?? {},
        isLoading,
    };
};
